import axios from "axios";
import { BRAND } from "./brand";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const getToken = () => {
  try { return localStorage.getItem(BRAND.tokenKey) || ""; } catch { return ""; }
};
export const setToken = (t) => {
  try { t ? localStorage.setItem(BRAND.tokenKey, t) : localStorage.removeItem(BRAND.tokenKey); } catch { /* noop */ }
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// URL autenticada para <img>, <video>, <iframe>, enlaces de descarga
export const fileUrl = (path) => (path ? `${API}/files/${path}?auth=${encodeURIComponent(getToken())}` : "");

export const apiErr = (e, fallback = "Ocurrió un error") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  if (e?.code === "ERR_NETWORK") return "No hay conexión con el servidor. Si el panel estuvo inactivo, espera unos segundos y reintenta.";
  return fallback;
};
